<template>
  <div
    class="search-results-container"
  >
    <div class="bottom-padding">
      <ul>
        <li
          v-if="searchData.FirstName.length > 0"
          v-html="$t('results.li1a', {FirstName: searchData.FirstName, LastName: searchData.LastName, DOB: searchData.birthdate})"
        />
        <li
          v-else
          v-html="$t('results.li1b', {PID: searchData.PID})"
        />
        <li><i> {{ $t('results.li2', { updateDate: updateDate() } ) }} </i> </li>
      </ul>
    </div>
    <div class="search-results-container">
      <div
        v-for="(item, index) in searchResults"
        :key="index"
        class="border-left result"
      >
        <div class="padding-top-bottom">
          <p class="padding-top-bottom">
            <font-awesome-icon
              icon="user"
              class="icon"
            />{{ $t('results.text', {FirstName: properCase(item.firstName), LastName: properCase(item.lastName), PID: item.ppn}) }}
          </p>
          <p class="padding-top-bottom">
            <font-awesome-icon
              icon="map-marker-alt"
              class="icon"
            /> <a
              target="_blank"
              :href="facility(item).facURL"
            ><b>{{ facility(item).facName }}</b></a>
          </p>
        </div>
      </div>
    </div>
    <button
      class="button custom"
      @click="clearData"
    >
      {{ $t('button.new') }}
    </button>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'SearchResults',
  props: {
  },
  methods: {
    properCase(str) {
      let properCase = str.split(' ').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
      return properCase;
    },
    updateDate() {
      // console.log("updateDate", moment(this.$store.state.searchResults[0].lastUpdated, 'LL'));
      if (!this.$store.state.searchResults[0]) {
        return '';
      }
      return moment(this.$store.state.searchResults[0].lastUpdated).format('LLLL').toString();
    },
    facility(item) {
      // console.log("item", item);
      let location = item.location.trim();
      let info = location === "PICC" ? { name: "Philadelphia Industrial Correctional Center",
        url: "https://www.phila.gov/prisons/Facilities/Pages/IndustrialCorrectionalCenter.aspx" } :
        location === "RCF" ? { name: "Riverside Correctional Facility",
          url: "https://www.phila.gov/prisons/Facilities/Pages/RiversideCorrectionalFacility.aspx" }:
          location === "DC" ? { name: "Detention Center",
            url: "https://www.phila.gov/prisons/Facilities/Pages/DetentionCenter.aspx" }:
            location === "CFCF" ?{ name: "Curran-Fromhold Correctional Facility",
              url: "https://www.phila.gov/prisons/Facilities/Pages/Curran-FromholdCorrectionalFacility.aspx" }:
              location === "ASDCU" ? { name: "Alternative and Special Detention",
                url:"https://www.phila.gov/prisons/Facilities/Pages/AlternativeSpecialDetention.aspx" }:
                location === "OJ" ? { name: "Not Available: Please call for assistance",
                  url: "" }:
                  location === { name: "Not Available: Please call for assistance",
                    url: "" };

      return { facName: info.name + " (" + location + ")", facURL: info.url };
    },
  },
};
</script>
